export default "__VITE_ASSET__B1q5fvy0__$_?url__"